import axios from '@/service/request';

// 获取语言
export const getLanguages = params => axios.get('/public/getNation', { params: { ...params } });

// 公共配置接口
export const getPublicConfig = params => axios.get('/public/getConfigV2', { params: { ...params } });

// 上传作品
export const uploadFile = params => axios.post('/upload/add', params);

// 短视频-电影任务进度
export const addShortTask = params => axios.post('/task/addShortTask', params);

// 广告位点击统计
export const analysis = params => axios.post('/analysis/ad', params);

// 下载点击统计
export const downloadAnalysis = params => axios.post('/analysis/download', params);

// 获取app信息
export const getApp = params => axios.get('/public/getApp', { params: { ...params } });

//  作者-粉丝团数量
export const authorGroupCount = () => axios.get('/public/authorGroup');

// 获取应用列表
export const getAppsList = params => axios.get('/apply/getList', { params: { ...params } });
